import { clearedFilters } from '../../shared/deliveryDates';
import deliveryDatesApi from '../../api/deliveryDates';

const SCHEDULE_POPUP_VALID_MS = 5 * 60 * 1000; //5 min

export default {
    namespaced: true,
    state: {
        lastClicked: null,
        filters: { ...clearedFilters },
        offsetClicked: 0,
        schedulePopupList: {
            loading: false,
            receivedAt: null,
            list: null,
        },
    },
    actions: {
        validateSchedulePopup({ commit, dispatch, state }) {
            if (state.schedulePopupList.list) {
                const timeStampMs = Date.now();
                if (
                    !state.schedulePopupList.receivedAt ||
                    state.schedulePopupList.receivedAt +
                        SCHEDULE_POPUP_VALID_MS <=
                        timeStampMs
                ) {
                    commit(
                        'deliveryDates/setSchedulePopupList',
                        { list: null, receivedAt: null, loading: false },
                        { root: true }
                    );
                }
            }
        },
        fetchSchedulePopupList({ commit, dispatch, state }) {
            if (
                !state.schedulePopupList.list &&
                !state.schedulePopupList.loading
            ) {
                commit(
                    'deliveryDates/setSchedulePopupList',
                    { list: null, receivedAt: null, loading: true },
                    { root: true }
                );
                deliveryDatesApi
                    .listDeliveryDatesForDeliveryMethod(-1, false, true, null)
                    .then((response) => {
                        commit(
                            'deliveryDates/setSchedulePopupList',
                            {
                                list: response.data.data || [],
                                receivedAt: Date.now(),
                                loading: false,
                            },
                            { root: true }
                        );
                    })
                    .finally(() => {
                        commit(
                            'deliveryDates/setSchedulePopupList',
                            { loading: false },
                            { root: true }
                        );
                    });
            }
        },
    },
    mutations: {
        setSchedulePopupList(state, newProps) {
            state.schedulePopupList = {
                ...state.schedulePopupList,
                ...newProps,
            };
        },
        setLastClicked(state, deliveryDateId) {
            state.lastClicked = deliveryDateId;
        },
        setFilters(state, filters) {
            state.filters = { ...filters };
        },
        setOffsetClicked(state, offset) {
            state.offsetClicked = offset;
        },
    },
    getters: {
        getSchedulePopupList(state) {
            return state.schedulePopupList;
        },
        getLastClicked(state) {
            return state.lastClicked;
        },
        getFilters(state) {
            return state.filters;
        },
        getOffsetClicked(state) {
            return state.offsetClicked;
        },
    },
};
